import axios from "axios";
export default {
  fetchByPages: (id, pageNum = 1, perPage = 10, cancelToken) =>
    axios.get(`/api/products/${id}/serialAll?per_page=${perPage}&page=${pageNum}`, { cancelToken }),

  searchByParamsAndGetByPages: (id, params, page = 1, per_page = 10, cancelToken) =>
    axios.get(`/api/products/${id}/serialAll`, { params: { ...params, per_page, page }, cancelToken })
};
